// src/app/store/user/user.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as UserActions from '../users/users.actions';
import { UsersService } from '../../core/service/users.service';

@Injectable()
export class UserEffects {
    constructor(
        private actions$: Actions,
        private usersService: UsersService
    ) { }
    // Load Users
    // users.effects.ts
    // loadUsers$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(UserActions.loadUsers),
    //         mergeMap(({ pagination }) =>
    //             this.usersService.getUsers(pagination).pipe(
    //                 map(response =>
    //                     UserActions.loadUsersSuccess({
    //                         users: response.data,
    //                         total: response.totalRecords
    //                     })
    //                 ),
    //                 catchError(error => of(UserActions.loadUsersFailure({ error })))
    //             )
    //         )
    //     )
    // );

    // Add User
    addUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.addUser),
            mergeMap(({ user }) =>
                this.usersService.addUser(user).pipe(
                    map(newUser => UserActions.addUserSuccess({ user: newUser })),
                    catchError(error => of(UserActions.addUserFailure({ error })))
                )
            )
        ));


    // Update User
    updateUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.updateUser),
            mergeMap(({ user }) =>
                this.usersService.updateUser(user).pipe(
                    map(updatedUser => UserActions.updateUserSuccess({ user: updatedUser })),
                    catchError(error => of(UserActions.updateUserFailure({ error })))
                )
            )
        ));

    // Delete User
    deleteUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.deleteUser),
            mergeMap(({ id }) =>
                this.usersService.deleteUser(id).pipe(
                    map(() => UserActions.deleteUserSuccess({ id })),
                    catchError(error => of(UserActions.deleteUserFailure({ error })))
                )
            )
        )
    );


}